import { defineStore } from 'pinia'
/**
 * 菜单位置存储
 */
export const useMenuStore = defineStore('menu', {
    state: () => ({
        menu_index: 0
    }),
    getters: {
        getMenuIndex(state): number {
            return state.menu_index;
        }
    },
    actions: {
        setMenuIndex(index: number) {
            this.menu_index = index;
        }
    }
})
